import { ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";

export function useTabState(validTabs, defaultTab, { history = "push" } = {}) {
  const defaultTab_ = validTabs.includes(defaultTab)
    ? defaultTab
    : validTabs[0];
  const route = useRoute();
  const router = useRouter();

  const tab = ref(
    validTabs.includes(route.query.tab) ? route.query.tab : defaultTab_
  );

  // The URL is the source of truth, so browser Back/Forward moves between tabs
  // instead of silently leaving the state behind.
  watch(
    () => route.query.tab,
    (value) => {
      tab.value = validTabs.includes(value) ? value : defaultTab_;
    }
  );

  function setTab(t) {
    if (!validTabs.includes(t) || t === tab.value) return;
    tab.value = t;
    const query = { ...route.query, tab: t === defaultTab_ ? undefined : t };
    router[history]({ ...route, query });
  }

  return { tab, setTab };
}
